export default "__VITE_ASSET__DmDD61cY__"